import { render, staticRenderFns } from "./profitToatalAnalysis.vue?vue&type=template&id=4e445210&scoped=true&"
import script from "./profitToatalAnalysis.vue?vue&type=script&lang=js&"
export * from "./profitToatalAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e445210",
  null
  
)

export default component.exports